
// SVG Icon: video
export default { id: "terriajs-video" };
export const id = "terriajs-video";
export const name = "video";
